import { Form, InputNumber, Select } from '@pankod/refine-antd';
import { EDiscountEntryType } from 'utilities/discount-entry';

type UnitDiscountFormItemProps = {
  disabled?: boolean;
};

// Unit Discount as % of the line or TK per unit. The form fields are `discountEntryValue` and
// `discountEntryType`.
export const UnitDiscountFormItem: React.FC<UnitDiscountFormItemProps> = ({ disabled }) => (
  <Form.Item
    label="Unit Discount"
    name="discountEntryValue"
    rules={[{ required: false }, { type: 'number', min: 0 }]}
  >
    <InputNumber
      disabled={disabled}
      style={{ width: '100%' }}
      min={0}
      precision={2}
      addonAfter={
        <Form.Item name="discountEntryType" noStyle>
          <Select disabled={disabled} style={{ width: 70 }}>
            <Select.Option value={EDiscountEntryType.AmountPerUnit}>TK</Select.Option>
            <Select.Option value={EDiscountEntryType.Percent}>%</Select.Option>
          </Select>
        </Form.Item>
      }
    />
  </Form.Item>
);
